// Load sentry first so it can register early
import Raven from "./legacy/helpers/raven_client";

// Polyfill localStorage
import "./legacy/helpers/localStorage";
import $ from "jquery";
// CSS
require("../sass/core.sass");

// page CSS that was previously in templates
// leaving this here so it's easy to find
require("../sass/pages/about.sass");
require("../sass/pages/about-nounji.sass");
require("../sass/pages/allauth.sass");
require("../sass/pages/app-confirm-upgrade.sass");
require("../sass/pages/app-connect.sass");
require("../sass/pages/app-download.sass");
require("../sass/admin.sass");
require("../sass/pages/admin.sass");
require("../sass/pages/billing.sass");
require("../sass/pages/creators.sass");
require("../sass/pages/developers.sass");
require("../sass/pages/facebook-connect-option.sass");
require("../sass/pages/flat-page.sass");
require("../sass/pages/forgot-password.sass");
require("../sass/pages/handbook.sass");
require("../sass/pages/iconathon.sass");
require("../sass/pages/logout.sass");
require("../sass/pages/royalties.sass");
require("../sass/pages/settings.sass");
require("../sass/pages/suspended-user-view.sass");
require("../sass/pages/team.sass");
require("../sass/pages/teams.sass");
require("../sass/pages/topsites-preview.sass");
require("../sass/pages/upload.sass");

var React = require("react");
var ReactDOM = require("react-dom");
import store from "./stores/reduxStore";

// Sometimes /js18n/ doesn't load in time for some reason
// Many components use gettext in their render methods so
// stub it out just it case
if (!global.gettext) {
    global.gettext = (str) => str;
}

// A few old versions of Firefox dont have isSameNode
// isEqualNode is not strictly identical, but close enough for
// our purposes
if (!global.HTMLElement.prototype.isSameNode) {
    global.HTMLElement.prototype.isSameNode =
        global.HTMLElement.prototype.isEqualNode;
}

// globals
require("./legacy/js/_banner").default;
require("./legacy/js/_buttons").default;
require("./legacy/js/clean_form").default;
require("./legacy/helpers/csrf_setup").default();
require("./legacy/js/_engage").default;
require("./legacy/js/_image-error").default;
require("./legacy/js/_logout").default;
require("./legacy/helpers/jQserializeObject").default;
require("./legacy/js/logout_link").default;
require("./legacy/js/_tabs").default;
require("./legacy/js/topsites_preview").default;
require("./legacy/js/welcome_modal").default;

var components = {
    // new files to be shared with photos project:
    nounproject_header: require("./containers/nounproject-header-parent")
        .default,
    profile_photos: require("./components/ProfilePhotos").default,

    // new jsx files that use Redux!
    autodownloadmacapp: require("./components/auto-download-mac-app").default,
    nounproject: require("./containers/nounproject").default,
    nounproject_footer: require("./components/nounproject-footer").default,
    Dashboard: require("./components/dashboard/dashboard").default,
    DashboardNav: require("./components/dashboard/dashboard-nav").default,
    InfiniteActiveUploads: require("./components/dashboard/active-uploads/infinite-active-uploads")
        .default,
    TeamSignup: require("./components/billing/forms/team-signup").default,
    SettingsCardForm: require("./components/billing/forms/settings-card/settings-card-form.jsx")
        .default,
    ProUpgradeBilling: require("./components/billing/forms/pro-upgrade-billing")
        .default,
    TeamSettingsCardForm: require("./components/billing/forms/settings-card/team-settings-card-form.jsx")
        .default,
    AboutVideoModalTrigger: require("./components/modals/about-video-modal-trigger.jsx")
        .default,
    PhotosMailchimpSignup: require("./components/photos-mailchimp-signup"),
    WelcomeModalTrigger: require("./components/modals/welcome-modal-trigger.jsx")
        .default,

    // legacy jsx files ported over from cjsx
    collectionlist: require("./legacy/components/collectionlist_parent")
        .default,
    footer: require("./legacy/components/footer").default,

    // non jsx code that was ported over from coffeescript
    about: require("./legacy/js/about").default,
    api_usage: require("./legacy/js/api_usage").default,
    app_video: require("./legacy/js/app_video").default,
    avatar: require("./legacy/js/avatar").default,
    buttons: require("./legacy/js/_buttons").default,
    creators: require("./legacy/js/creators").default,
    developers: require("./legacy/js/developers").default,
    handbook: require("./legacy/js/handbook").default,
    legal_tab: require("./legacy/js/legal_tab").default,
    notifications: require("./legacy/js/notifications").default,
    pricing: require("./legacy/js/pricing").default,
    royalties: require("./legacy/js/royalties").default,
    section_nav: require("./legacy/js/section-nav").default,
    settings: require("./legacy/js/settings").default,
    team_page: require("./legacy/js/team_page").default,
    teams: require("./legacy/js/teams").default,
};

var lazyComponents = {
    accounts: () => import("./legacy/js/accounts").then((mod) => mod.default),
    kit_scroll: () =>
        import("./legacy/js/kit_scroll").then((mod) => mod.default),
    upload: () => import("./legacy/js/upload").then((mod) => mod.default),
    plugin: () => import("./containers/plugin").then((mod) => mod.default),
    _kits: () => import("./legacy/js/_kits").then((mod) => mod.default),
    NewKitFormWrapper: () =>
        import("./components/kits/new-kit-form-wrapper").then(
            (mod) => mod.default
        ),
};

$(".react-es6-component").each(function () {
    var args, Component, componentName, comp, CompInstance;
    componentName = $(this).data("componentName");
    Component = components[componentName];
    args = $(this).data("componentArgs");

    if (typeof args == "string") {
        try {
            args = JSON.parse(args);
        } catch (e) {
            console.warn("invalid json", args);
            args = [];
        }
    }

    var argProps = {};
    if (args) {
        args.forEach((arg) => {
            for (var key in arg) {
                argProps[key] = arg[key];
            }
        });
    }

    // Landing module has no react component, so we shouldn't try to render it
    if (typeof Component == "function") {
        // note var Component must be capitalized otherwise jsx turns the variable name into a string

        ReactDOM.render(<Component args={argProps} />, this);
    } else {
        if (Component && args) {
            //this function allows us to apply args without changing the component's scope
            var comp = function () {
                return Component.apply(this, args);
            };
            comp.prototype = Component.prototype;
            CompInstance = new comp();
        } else if (Component) {
            CompInstance = new Component();
        } else if (lazyComponents[componentName]) {
            lazyComponents[componentName]().then((C) =>
                ReactDOM.render(<C args={argProps} />, this)
            );
            return;
        } else {
            console.warn("Component not found: " + componentName);
        }

        ReactDOM.render(<CompInstance />, this);
    }
});

// for non-react components
$(".js-component").each(function () {
    var args, Component, componentName, comp, CompInstance;
    componentName = $(this).data("componentName");
    Component = components[componentName];
    if (!Component) {
        Component = lazyComponents[componentName];
        if (!Component) {
            throw new Error(`JS Component not found ${componentName}`);
        }
        return Component().then((Component) => new Component());
    }
    new Component();
});
